// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_3tmIQ","paginationLink":"_2ir6g"};